/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_Externals_PlaceholderInputs */



/**
* | output |
* | --- |
* | "email@example.com, another@example.com" |
*
* @param {Iconik_Publish_Reviewers_Externals_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_externals_placeholder = /** @type {((inputs?: Iconik_Publish_Reviewers_Externals_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_Externals_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "de") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "ru") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "ja") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "hi") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
	return /** @type {LocalizedString} */ ("email@example.com, another@example.com")
});